import { render, staticRenderFns } from "./RedemptionManagement.vue?vue&type=template&id=ce2e9b64&scoped=true"
import script from "./RedemptionManagement.vue?vue&type=script&lang=js"
export * from "./RedemptionManagement.vue?vue&type=script&lang=js"
import style0 from "./RedemptionManagement.vue?vue&type=style&index=0&id=ce2e9b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2e9b64",
  null
  
)

export default component.exports